<template>
  <div class="hover:bg-ctp-accent hover:text-ctp-crust transition rounded-md p-1.5">
    <slot />
  </div>
</template>
